import { useFilestackImageUrl } from "../../../hooks/useFilestackImageUrl";

const FORM_IMAGE_WIDTH = 2400;

export const useFormStyleImageUrl = (handle?: string | null): string | null =>
  useFilestackImageUrl(handle, { width: FORM_IMAGE_WIDTH });
